import script from "./CreateInvoice.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreateInvoice.vue?vue&type=script&lang=ts&setup=true"

import "./CreateInvoice.vue?vue&type=style&index=0&id=744f1b1c&lang=scss&scoped=true"

import exportComponent from "/home/forge/saf.groupebiou.bj/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-744f1b1c"]])

export default __exports__